import React, { useEffect, useState, useCallback } from 'react';
import { getAllOMRById } from '../../Services/AllAPIs';
import { useParams } from 'react-router-dom';
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [omr, setOmr] = useState(null);
    const [error, setError] = useState(null);
    const { id } = useParams();

    // Using useCallback to memoize the getOMRData function
    const getOMRData = useCallback(() => {
        getAllOMRById(id)
            .then((res) => {
                setOmr(res.data);
                setLoader(false);
            })
            .catch((error) => {
                console.log("Error fetching OMR data:", error);
                setError("An error occurred while fetching OMR data.");
                setLoader(false);
            });
    }, [id]);

    useEffect(() => {
        getOMRData();
    }, [getOMRData]);

    if (loader) {
        return <LoadingSpinner />;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    return (
        <div id='omrDetails'>
            <div className="container mt-5">
                <h2 className="my-heading">OMR ANSWER Keys 2024 Exam</h2>

                {omr && omr.title ? (
                    <h3>{omr.title}</h3>
                ) : (
                    <h3>No Data Available</h3>
                )}

                <p>
                    Press Release:
                    {omr && omr.press_release ? (
                        <a href={omr.press_release} className="btn btn-primary btn-download" target="_blank" rel="noreferrer">
                            Download
                        </a>
                    ) : (
                        <span style={{ color: "red" }}>No Press Release Available</span>
                    )}
                </p>

                {omr && omr.class_or_exam && omr.class_or_exam.length > 0 ? (
                    omr.class_or_exam.map((classOrExam, index) => (
                        <div className="row" key={index}>
                            <div className="col-md-12 col-12">
                                <div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th colSpan={3}>{classOrExam.name}</th>
                                            </tr>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Subject Code</th>
                                                <th>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {classOrExam.subjectcode && classOrExam.subjectcode.map((subject, subjectIndex) => (
                                                <tr key={subjectIndex}>
                                                    <td>{subjectIndex + 1}</td>
                                                    <td>{subject.name}</td>
                                                    <td>
                                                        <a
                                                            href={subject.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-primary btn-download"
                                                        >
                                                            Download
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No OMR data available.</p>
                )}
            </div>
        </div>
    );
};

export default Main;
